import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=3dba6e0f&scoped=true"
var script = {}
import style0 from "./Pro.vue?vue&type=style&index=0&id=3dba6e0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba6e0f",
  null
  
)

export default component.exports